import { expVal } from '@atlassian/jira-feature-experiments';
import { useBacklogSelector } from '../index.tsx';
import { getIsCompanyManaged } from '../selectors/app/index.tsx';

export const useIsFilterRefinementEnabled = () =>
	!useBacklogSelector(getIsCompanyManaged) &&
	expVal('filter_refinement_in_tmp_backlog', 'isEnabled', false);
